import { getValueAndUnit, remToPx } from 'polished';

/**
 * Attempts to extract `px` value from input,
 * if it fails to extract px value then `undefined` will be returned
 */
const getPxValue = (input: string | number | undefined): number | undefined => {
  if (!input && typeof input !== 'string') {
    return undefined;
  }

  if (typeof input === 'number') {
    return input;
  }

  const [value, unit] = getValueAndUnit(input);

  if (typeof value !== 'number' || Number.isNaN(value)) {
    return undefined;
  }

  if (!unit) return value;

  if (unit === 'px') {
    return value;
  }

  if (unit === 'rem') {
    return getValueAndUnit(remToPx(value))[0];
  }

  return undefined; // couldn't get px value (Ex. it was %, em or something else)
};

export default getPxValue;
